/**
 * @ngdoc component
 * @name mx.shell:mxToolbarActions
 * @module mx.shell
 * @requires {@ref mx.shell.ActionManagerService mx.shell.ActionManagerService}
 * @requires $scope
 * @description
 * A toolbar that contains a set of {@ref mx.shell:mxAction action buttons}.<br>
 */

angular.module('mx.shell').component('mxToolbarActions', {
	bindings: {},
	controller: MxToolbarActionsCtrl,
	controllerAs: 'vm',
	templateUrl: 'components/mx-toolbar-actions/mx-toolbar-actions.html',
});

MxToolbarActionsCtrl.$inject = ['mx.shell.ActionManagerService', 'mx.shell.EventService', 'mx.shell.ContextService', '$scope'];

function MxToolbarActionsCtrl(actionManagerService, eventService, contextService, $scope) {
	const vm = this;
	const actionTypes = [mx.shell.ActionContextType.None, mx.shell.ActionContextType.Single, mx.shell.ActionContextType.Multiple];

	vm.$onInit = function () {
		vm.selectedObjects = [];
		if (contextService.selectedObjects) {
			_handleObjectSelectionChanged(null, contextService.selectedObjects);
		}
		if (!contextService.actionsContext) {
			contextService.actionsContext = new mx.shell.ActionsContext([], [], mx.shell.ActionUiZone.Application);
		} else {
			if (contextService.actionsContext.uiZone === mx.shell.ActionUiZone.Application) {
				setActionsContext(contextService.actionsContext);
			} else {
				setActionsContext(new mx.shell.ActionsContext([], [], mx.shell.ActionUiZone.Application));
			}
		}
	};

	eventService.subscribeTo(mx.shell.EventCodes.ActionsContextChanged, (eventObj, context) => setActionsContext(context), $scope);

	eventService.subscribeTo(mx.shell.EventCodes.ObjectSelectionChanged, _handleObjectSelectionChanged, $scope);
	eventService.subscribeTo(
		mx.shell.EventCodes.SidePanelCurrentViewChanged,
		function (eventObj, view) {
			if (view) {
				_handleObjectSelectionChanged(eventObj, view.context ? [view.context] : [{ _type: view.type }]);
			}
		},
		$scope
	);

	function setActionsContext(context) {
		if (context && context.uiZone === mx.shell.ActionUiZone.Application) {
			actionManagerService
				.getActions(context, actionTypes, vm.selectedObjects)
				.then(function (actions) {
					return actionManagerService.filterActions(actions);
				})
				.then(function (filteredActions) {
					vm.actions = filteredActions;
				});
		}
	}

	function _handleObjectSelectionChanged(e, objectsCollection) {
		let objectTypes = [];

		let selectedItems = [];

		if (Array.isArray(objectsCollection)) {
			selectedItems = objectsCollection;
		} else {
			objectsCollection.objects = objectsCollection.objects || [];
			if (objectsCollection.objects.length > 0) {
				selectedItems = objectsCollection.objects;
			}
		}

		if (selectedItems.length > 0) {
			objectTypes = selectedItems
				// Get array of types
				.map(function (item) {
					return item._type;
				})
				// Filter just unique types
				.filter(function (_type, i, newArr) {
					return _type && _type !== 'undefined' && newArr.indexOf(_type) === i;
				});

			if (objectTypes.length > 0) {
				vm.selectedObjects = selectedItems;
			}
		}
	}
}
